import * as util from 'lib/utility'; //eslint-disable-line

export const UPDATE_DATA = 'UPDATE_DATA';
export const UPDATE_DATA_FAIL = 'UPDATE_DATA_FAIL';
export const UPDATE_DATA_SUCCESS = 'UPDATE_DATA_SUCCESS';
export const FETCH_DATA = 'FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAIL = 'FETCH_DATA_FAIL';
export const INSERT_DATA = 'INSERT_DATA';
export const INSERT_DATA_FAIL = 'INSERT_DATA_FAIL';
export const INSERT_DATA_SUCCESS = 'INSERT_DATA_SUCCESS';
export const INSERT_CAL_DATA = 'INSERT_CAL_DATA';
export const INSERT_CAL_DATA_SUCCESS = 'INSERT_CAL_DATA_SUCCESS';
export const INSERT_CAL_DATA_FAIL = 'INSERT_CAL_DATA_FAIL';
export const FETCH_DRAFTS_DATA = 'FETCH_DRAFTS_DATA';
export const FETCH_DRAFTS_DATA_SUCCESS = 'FETCH_DRAFTS_DATA_SUCCESS';
export const FETCH_DRAFTS_DATA_FAIL = 'FETCH_DRAFTS_DATA_FAIL';
export const UPDATE_DRAFT = 'UPDATE_DRAFT';
export const UPDATE_DRAFT_FAIL = 'UPDATE_DRAFT_FAIL';
export const UPDATE_DRAFT_SUCCESS = 'UPDATE_DRAFT_SUCCESS';
export const FETCH_DRAFTS_ID_DATA = 'FETCH_DRAFTS_ID_DATA';
export const FETCH_DRAFTS_DATA_ID_SUCCESS = 'FETCH_DRAFTS_DATA_ID_SUCCESS';
export const FETCH_DRAFTS_DATA_ID_FAIL = 'FETCH_DRAFTS_DATA_ID_FAIL';
export const UPDATE_MISC = 'UPDATE_MISC';
export const UPDATE_MISC_FAIL = 'UPDATE_MISC_FAIL';
export const UPDATE_MISC_SUCCESS = 'UPDATE_MISC_SUCCESS';

const debug = _debug('app:popup');
const initialState = {
  value: 0,
  radioValue: 0,
  date: 0,
  contactData: [],
  isLoading: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_DATA :
      debug(state);
      return {
        ...state,
        isLoading: true
      };
    case UPDATE_DATA_SUCCESS :
      return {
        ...state,
        isLoading: false
      };
    case UPDATE_DATA_FAIL :
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    case FETCH_DATA :
      return {
        ...state,
        isLoading: true
      };
    case FETCH_DATA_SUCCESS :
      return {
        ...state,
        isLoading: false,
        contactData: action.result
      };
    case FETCH_DATA_FAIL :
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    case INSERT_DATA :
      return {
        ...state,
        isLoading: true
      };
    case INSERT_DATA_SUCCESS :
      return {
        ...state,
        isLoading: false,
        contactData: action.result
      };
    case INSERT_DATA_FAIL :
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    case INSERT_CAL_DATA :
      return {
        ...state,
        isLoading: true
      };
    case INSERT_CAL_DATA_SUCCESS :
      return {
        ...state,
        isLoading: false,
        contactData: action.result
      };
    case INSERT_CAL_DATA_FAIL :
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    case UPDATE_MISC :
      debug(state);
      return {
        ...state,
        isLoading: true
      };
    case UPDATE_MISC_SUCCESS :
      return {
        ...state,
        isLoading: false
      };
    case UPDATE_MISC_FAIL :
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    default:
      return state;
  }
}
export const fetchContactData = (id) => {
  const request = util.fetchContactData(id);
  return {
    types: [FETCH_DATA, FETCH_DATA_SUCCESS, FETCH_DATA_FAIL],
    promise: request
  };
};
export const fetchDraftsData = () => {
  const request = util.fetchDraftsData();
  return {
    types: [FETCH_DRAFTS_DATA, FETCH_DRAFTS_DATA_SUCCESS, FETCH_DRAFTS_DATA_FAIL],
    promise: request
  };
};
export const updateContactData = (data) => {
  const request = util.updateContactData(data);
  return {
    types: [UPDATE_DATA, UPDATE_DATA_SUCCESS, UPDATE_DATA_FAIL],
    promise: request
  };
};
export const insertContactData = (data) => {
  const request = util.insertContactData(data);
  return {
    types: [INSERT_DATA, INSERT_DATA_SUCCESS, INSERT_DATA_FAIL],
    promise: request
  };
};
export const saveEventToCalendar = (eventData, contactData) => {
  const request = util.insertToCalendar(eventData, contactData);
  return {
    types: [INSERT_CAL_DATA, INSERT_CAL_DATA_SUCCESS, INSERT_CAL_DATA_FAIL],
    promise: request
  };
};
export const fetchDraftsById = (policyId) => {
  const request = util.fetchDraftsById(policyId);
  return {
    types: [FETCH_DRAFTS_ID_DATA, FETCH_DRAFTS_DATA_ID_SUCCESS, FETCH_DRAFTS_DATA_ID_FAIL],
    promise: request
  };
};
export const updateCicaDraft = (data) => {
  const request = util.updateCicaDraft(data);
  return {
    types: [UPDATE_DRAFT, UPDATE_DRAFT_SUCCESS, UPDATE_DRAFT_FAIL],
    promise: request
  };
};
export const updateToMiscData = (data) => {
  const request = util.updateToMiscData(data);
  return {
    types: [UPDATE_MISC, UPDATE_MISC_SUCCESS, UPDATE_MISC_FAIL],
    promise: request
  };
};



// WEBPACK FOOTER //
// ./src/state/modules/popup.js